import * as React from 'react';
import Resizer from 'react-image-file-resizer';
import uuid from 'react-uuid';


import ActiveStorageDirectUploader from './ActiveStorageDirectUploader';

import FileInput from './FileInput';
import PhotoUpload from './PhotoUpload';
import MobileInstructions from './MobileInstructions';

const MAX_PHOTO_SIZE = 1920; // Pixels in either dimension
const PHOTO_QUALITY = 70; // Jpeg compression

const resizeImage = (file: any) => new Promise(resolve => {
  Resizer.imageFileResizer(file, 
    MAX_PHOTO_SIZE, MAX_PHOTO_SIZE,'JPEG', PHOTO_QUALITY, 0,
    (uri: any) => {
      resolve(uri);
    },
    'base64'
  );
});


/* Determines whether this device is a desktop */
const isDesktop = () => {
  // Portrait is a mobile
  if(screen.width < screen.height) return false;

  // Small screens are mobiles
  if(screen.width < 800) return false;

  // That's ok for now
  return true;
}



type Props = {
  createUrl: string, 
  mobileUrl?: string,
  trackingUrl?: string,
}
class PhotoUploader extends React.Component<Props> {
  constructor(props: any) {
    super(props);
  }

  state = {
    uploads: [],
  }

  beginUpload = (upload: any) => {
    // We need to convert the resizeImage result into a blob
    fetch(upload.imageData)
      .then(res => res.blob())
      .then( blob => {
        const file = new File([blob], upload.file.name, { type: blob.type });

        const uploader = new ActiveStorageDirectUploader(file);
        uploader.uploadFile({
          onComplete: (railsBlob) => {
            this.completeUpload(upload, railsBlob.signed_id);
          },
          onError: (error) => {
            console.error(error);
          }, 
          onProgress: (percentComplete) => {
            this.setState({
              uploads: this.state.uploads.map( u => {
                if(u.id != upload.id) return u;
                return {
                  ...u,
                  progress: percentComplete,
                }
              })
            });
          },
        })
      });
  }

  completeUpload = (upload: any, blobId: any) => {
    console.log("Ready to create record", upload, blobId)

    let formData = new FormData();
    formData.append('photo[image]', blobId);
    //formData.append('photo[source]', 'customer');

    fetch(this.props.createUrl, {
      method: 'POST', 
      body: formData,
    })
      .then ( response => response.json() )
      .then ( json => {
        console.log(json);
        this.setState({
          uploads: this.state.uploads.map( u => {
            if(u.id != upload.id) return u;
            return {
              ...upload,
              status: 'complete',
              progress: 100,
              token: json.token, 
            };
          })
        })
      });
  }

  handleFilesAdded = (files: FileList) => {
    [...files].map(file => {
      resizeImage(file).then( base64 =>  {
        var upload = {
          id: uuid(),
          file: file, 
          imageData: base64,
          status: 'uploading',
          progress: 0,
        }

        this.beginUpload(upload);

        this.setState({
          uploads: [
            ...this.state.uploads,
            upload,
          ]
        })
      })
    });
  }

  handleRemoveFile = (token: any) => {
    fetch(`/photos/${token}`, {
      method: 'DELETE',
    })
    this.setState({
      uploads: this.state.uploads.filter( upload => upload.token != token ),
    })
  }

  renderConfirmation() {
    const { trackingUrl } = this.props;
    const anyComplete = this.state.uploads.some( u => u.status == 'complete' );
    if(!anyComplete) return null;

    return (
      <div className="alert alert-success mb-4">
        <p className="mb-0">
          Thanks for the photos, they&rsquo;ve been received and we&rsquo;ll be
          in touch if we need any more information or photos.
        </p>
        {/* OUT OF THE CHARITY'S IFRAME, not inside it. On the widget's
            confirm page this button is running in a cross-origin frame on the
            charity's own site - see public/widget.js - and the tracking page
            is sent with X-Frame-Options: SAMEORIGIN like every other page
            ApplicationController serves. Navigating the frame to it gets the
            donor a browser error page ("boxmove.com refused to connect")
            rather than their collection. _top is what widget/_find_charity_button
            does with its link out for the same reason; on the standalone
            mobile uploader, where there is no frame, it means the same as no
            target at all. */}
        { trackingUrl && (
          <a href={trackingUrl} target="_top" rel="noopener"
            className="btn btn-success mt-3">
            View your donation
          </a>
        )}
      </div>
    );
  }

  renderMobileInstructions() {
    const { mobileUrl } = this.props;
    if(!mobileUrl) return null;
    if(!isDesktop()) return null;

    return (
      <MobileInstructions url={mobileUrl} />
    );
  }

  render() {
    const { uploads } = this.state;
    const hasUploads = uploads.length > 0;

     return(
       <div className="card"><div className="card-body">
         <div className="d-flex">
           {this.renderMobileInstructions()}
           <div className="flex-fill d-flex flex-column ms-4">
             {this.renderConfirmation()}
             <div className="card mb-4" style={{ backgroundColor: '#f4f4f4', borderColor: '#ccc', borderWidth: 1 }}><div className="card-body">
               {!hasUploads && (
                 <p className="p-5 text-center lead text-muted">
                   No photos added yet</p>)} 

                 <div className="row">
                   {this.state.uploads.map( upload => 
                   <PhotoUpload {...upload} key={upload.id} 
                     onRemove={ () => this.handleRemoveFile(upload.token)} />
                 )}
                 </div>
             </div>
            </div>

             <FileInput 
               more={hasUploads}
               onFilesAdded={this.handleFilesAdded} /> 
           </div>
         </div>
       </div></div>
     );
  }
}
export default PhotoUploader;
